// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"12090066","355":"0661ed00","501":"a66efc19","670":"ecdb9c9f"}[chunkId] + ".chunk.js";
};